import React from 'react';
import './RiddleHistory.css';

const RiddleHistory = ({ riddles }) => {
  if (!Array.isArray(riddles) || riddles.length === 0) return null;

  // Show newest first.
  const items = [...riddles].reverse();

  return (
    <div className="riddle-history" aria-label="Riddle history">
      <div className="riddle-history-header">Your riddles for this word</div>
      <ol className="riddle-history-list">
        {items.map((text, idx) => (
          <li key={`${items.length - idx}-${String(text).slice(0, 24)}`}>
            {text}
          </li>
        ))}
      </ol>
    </div>
  );
};

export default RiddleHistory;

